import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";
import { Spacing } from "types/Spacing";

export const COLUMN_ORDER = `minmax(5rem, 5fr)  minmax(3rem, 2fr) 5rem ${dropdownEllipsisWidth}`;
export const COLUMN_GAP: Spacing = "large";
export const LEVEL_MARGIN = "3.2rem";
export const SPACE_TREE_LIST_ROW_TEST_ID = "space-tree-list-row";
